module.exports = __webpack_public_path__ + "img/brazil.2aab57b8.png";